module.exports = __webpack_public_path__ + "media/images/yappy-logo-eb317c49838d5d13052665219d5d993b.png";